import JSZip from 'jszip'
import saveAs from 'file-saver'
import Vue from 'vue'
import i18n from '../i18n'
import VesselUtils from './VesselUtils'

export default class DataExport {
  generateMailSubject () {
    return '[MAOC-N REQUEST]'
  }

  generateMailBody () {
    return 'The message body is important.'
  }
}

export const ImportUtils = {
  setComponentsDataModel: function (components, refs, data) {
    components.requestData.setData(data.request)

    Vue.nextTick(function () {
      for (const key in refs) {
        const item = refs[key]
        const component = components[item.ref]
        if (component) {
          component.setData(data[item.key])
        }
      }
    })
  }
}

export const ExportUtils = {
  getComponentsDataModel: function (components, exportData) {
    var data = {}
    for (const key in exportData) {
      const item = exportData[key]
      const component = components[item.ref]
      if (component) {
        data[item.key] = component.getData()
      }
    }

    return data
  },
  generatePackage: function (data, images, attachments, onComplete) {
    var zip = new JSZip()
    zip.file('README.txt', 'Readme File\n')
    zip.file('data.json', JSON.stringify(data, null, 2))

    if (images) {
      const folder = zip.folder('images')
      images.forEach(img => folder.file(img.name, img))
    }

    if (attachments) {
      const folder = zip.folder('attachments')
      attachments.forEach(attachment => folder.file(attachment.name, attachment))
    }

    const filename = ExportUtils.generateFileName(data) + '.mrq'

    zip.generateAsync({ type: 'blob' }).then(function (content) {
      onComplete()
      saveAs(content, filename)
    })
  },
  generateFileName: function (data) {
    const [day, month, year] = data.request_time.date.split('/')
    const dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    const timeStr = data.request_time.time.replace(/:/g, '')
    const timestampStr = dateStr + '-' + timeStr

    var requestStr = data.request.requestType
    if (requestStr !== 'registration') {
      requestStr = requestStr.concat('-' + data.request.requestNumber)
    }

    return timestampStr + '-' + requestStr + '-' + data.entity.country
  },
  packFileNames: function (files) {
    var filenames = []
    files.forEach(file => filenames.push(file.name))
    return filenames
  },
  copyObject: function (source, filters = []) {
    var target = {}
    Object.assign(target, source)

    Object.keys(target).forEach(function (key) {
      if (filters.includes(key)) {
        delete target[key]
      }

      if (key && (target[key] === '')) {
        delete target[key]
      }
    })

    return target
  },
  isObjectEmpty: function (obj) {
    if (!obj) {
      return true
    }

    var keys = Object.keys(obj)
    for (const idx in keys) {
      var key = keys[idx]
      if (key && (obj[key] !== '')) {
        return false
      }
    }
    return true
  },
  formatVesselRequiredActions (details) {
    var message = []

    if (details.no_action) {
      message.push(i18n.t('no_action', 'en'))
    }

    if (details.sighting_report) {
      message.push(i18n.t('sighting_report', 'en'))
    }

    if (details.airport_control) {
      message.push(i18n.t('airport_control', 'en'))
    }

    if (details.port_control) {
      message.push(i18n.t('port_control', 'en'))
    }

    if (details.vessel_boarding) {
      message.push(i18n.t('vessel_boarding', 'en'))
    }

    if (details.aeroplane_inspection) {
      message.push(i18n.t('aeroplane_inspection', 'en'))
    }

    if (details.crew_list) {
      message.push(i18n.t('crew_list', 'en'))
    }

    if (details.passenger_list) {
      message.push(i18n.t('passenger_list', 'en'))
    }

    if (details.vessel_inspection) {
      message.push(i18n.t('vessel_inspection', 'en'))
    }

    if (details.other_actions) {
      message.push(details.other_actions_info)
    }

    return message.join(', ')
  },
  vesselActionRequired (details) {
    return VesselUtils.vesselActionRequired(details)
  },
  arrayToCrewmember (item) {
    return {
      name: item[0],
      birthdate: item[1],
      nationality: item[2],
      rank: item[3],
      document_type: item[4],
      document_number: item[5]
    }
  }
}

export const FormatUtils = {}
